






import { Component, Vue, Inject, Watch, Prop } from 'vue-property-decorator';
import SendMessageForm from '@/components/SendMessageForm.vue';
Component.registerHooks(['beforeRouteLeave']);

@Component({
  components: {
    SendMessageForm,
  },
})
export default class SendMessage extends Vue {
  public isSendSuccess: boolean = false;

  public changeFlag(flag: boolean): void {
    this.isSendSuccess = flag;
  }

  public beforeRouteLeave(to: any, from: any, next: any) {
    if (!this.isSendSuccess) {
      const str: any = this.$t('warningTip.leaveFromForm');
      const answer = window.confirm(str);
      if (answer) {
        next();
      } else {
        next(false);
      }
    } else {
      next();
    }
  }
}
